import {botRulesConstants} from "../constants/botRulesConstants";
import {alertConstants} from "../constants/alertConstants";
import {alertActions} from "./alertActions";
import {botRulesServices} from "../../service/botRulesService";

export const botRulesActions = {
    fetch,
    remove,
    rerender,
    startLoading,
    stopLoading
};

function fetch() {
    return dispatch => {
        dispatch({type: botRulesConstants.BOT_RULES_LOADING_SPINNER});
        botRulesServices.fetch()
            .then((result) => {
                dispatch({type: botRulesConstants.BOT_RULES_GET_DATA, payload: {result}});
            }).catch((error) => {
                dispatch({type: alertConstants.ERROR, error});
            }
        );
    };
}

function remove(id) {
    return dispatch => {
        dispatch({type: botRulesConstants.BOT_RULES_LOADING_SPINNER});
        botRulesServices.remove({id})
            .then(() => {
                dispatch({type: botRulesConstants.BOT_RULES_RERENDER, payload: {rerender: true}});
            }).catch((error) => {
                dispatch({type: botRulesConstants.BOT_RULES_STOP_LOADING_SPINNER});
                dispatch(alertActions.error(error?.response?.data?.error));
            }
        );
    };
}

function rerender(rerender) {
    return dispatch => {
        dispatch({type: botRulesConstants.BOT_RULES_RERENDER, payload: {rerender}});
    };
}

function startLoading() {
    return dispatch => {
        dispatch({type: botRulesConstants.BOT_RULES_LOADING_SPINNER});
    }
}

function stopLoading() {
    return dispatch => {
        dispatch({type: botRulesConstants.BOT_RULES_STOP_LOADING_SPINNER});
    }
}